export const initialValuesAddPodcast = {
  feedData: {},
  podcastName: '',
  podcastUrl: '',
  podcastFiles: [],
};
